/**
 * jays-header-condensed.js
 * Toggles .header-condensed on .header-section past a scroll threshold, and
 * collapses the announcement bar. Purely additive — does NOT touch theme.js's
 * StickyHeader. No custom element, so it's soft-refresh safe.
 */
(function () {
  'use strict';

  const SCROLL_THRESHOLD = 60;

  const headerSection = document.querySelector('.header-section');
  if (!headerSection) return;
  const announcement = document.querySelector('[id$="__announcement-bar"]');

  let isCondensed = false;
  let ticking = false;

  // Condensing is a DESKTOP feature only. On mobile the header keeps its 2-row
  // layout (logo row + full-width search row) — the compact single-row inline
  // layout is wrong for mobile.
  const desktopMql = window.matchMedia('(min-width: 1024px)');

  function update() {
    ticking = false;
    const shouldCondense = desktopMql.matches && (window.scrollY || window.pageYOffset) > SCROLL_THRESHOLD;
    if (shouldCondense === isCondensed) return;
    isCondensed = shouldCondense;

    headerSection.classList.toggle('header-condensed', isCondensed);
    if (announcement && announcement.firstElementChild) {
      announcement.firstElementChild.classList.toggle('jays-topbar--condensed', isCondensed);
    }
  }

  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(update);
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  // Re-evaluate when crossing the desktop/mobile breakpoint (e.g. rotate/resize)
  if (desktopMql.addEventListener) {
    desktopMql.addEventListener('change', update);
  } else if (desktopMql.addListener) {
    desktopMql.addListener(update);
  }
  update(); // handle mid-scroll landings (back/forward nav)
})();
